import { useToast } from '@monorepo/shared/contexts';
import { useFormTemplateUpdate } from './useFormTemplateUpdate';

export const useSaveEditedFormTemplate = (props: {
  setIsDirty: (isDirty: boolean) => void;
}) => {
  const { setIsDirty } = props;
  const { showUserFriendlyErrorToast, success: showSuccessToast } = useToast();

  const [saveUpdatedFormTemplate, saveFormTemplateState] =
    useFormTemplateUpdate({
      config: {
        onSuccess: () => {
          showSuccessToast('Form saved.');
          setIsDirty(false);
        },
        onError: (error) => {
          showUserFriendlyErrorToast(error, `Unable to save form.`, {
            dontAutoHide: true,
          });
        },
      },
    });

  return [saveUpdatedFormTemplate, saveFormTemplateState] as const;
};
